import clsx, { type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export const cn = (...inputs: ClassValue[]) => twMerge(clsx(inputs));

export const normalizeValue = (value?: string | null): string | undefined => {
	if (value == null) {
		return undefined;
	}

	const unquoted = value.replace(/^[("'`]+|[)"'`]+$/g, '');
	const trimmed = unquoted.trim();

	if (trimmed === '') {
		return undefined;
	}

	return trimmed;
};
